import { forwardRef } from 'react';
import { Checkbox } from '@chakra-ui/react';

/** @typedef {import('@chakra-ui/react').CheckboxRootProps} CheckboxRootProps */
/** @typedef {import('react').RefAttributes<HTMLLabelElement>} LabelRefAttributes */
/** @type {import('react').ForwardRefExoticComponent<CheckboxRootProps & LabelRefAttributes>} */
const VCheckbox = forwardRef(({ children, checked, onCheckedChange, ...props }, ref) => (
  <Checkbox.Root ref={ref} checked={checked} onCheckedChange={onCheckedChange} {...props}>
    <Checkbox.HiddenInput />
    <Checkbox.Control />
    {children && <Checkbox.Label>{children}</Checkbox.Label>}
  </Checkbox.Root>
));

VCheckbox.displayName = 'VCheckbox';

export default VCheckbox;
